export default __webpack_public_path__ + "static/mifuture-1-0643993bce3ee13cca0d8c48593e9918.png";